<template>
  <div>
    <div class="writeBox writeBox1">
      <div class="writeItem">
        <label>mcn返点机构全称</label>
        <el-input class="input" v-model="editData.mcn_name" placeholder="请输入mcn返点机构全称" size='mini'></el-input>
      </div>
      <!-- <div class="writeItem">
                <label>mcn返点收入金额</label>
                <el-input class="input"  v-model="editData.mcn_rebate" placeholder="请输入mcn返点收入金额" @input="(val)=>{clearNoNum({value:val,valueName:'mcn_rebate',mainName:'editData'})}" size='mini' ></el-input>
            </div> -->
      <div class="writeItem">
        <label>mcn经手人</label>
        <el-select class="input" v-model="editData.mcn_handler" :disabled="true" size='mini' filterable placeholder="请选择">
          <el-option v-for="(item,index) in mediumList" :key="index" :label="item.real_name" :value="item.real_name">
          </el-option>
        </el-select>
      </div>
      <div class="writeItem">
        <label>机构到手金额</label>
        <el-input class="input" v-model="editData.organization_amount" placeholder="请输入机构到手金额" @input="(val)=>{clearNoNum({value:val,valueName:'organization_amount',mainName:'editData'})}" size='mini'></el-input>
      </div>
      <div class="writeItem">
        <label>mcn最终收入金额</label>
        <el-input class="input" v-model="editData.mcn_final_amount" placeholder="请输入mcn最终收入金额" @input="(val)=>{clearNoNum({value:val,valueName:'mcn_final_amount',mainName:'editData'})}" size='mini'></el-input>
      </div>
      <div class="writeItem">
        <label>mcn负责人</label>
        <el-select class="input" v-model="editData.mcn_user" size='mini' filterable placeholder="请选择">
          <el-option v-for="(item,index) in mediumList" :key="index" :label="item.real_name" :value="item.real_name">
          </el-option>
        </el-select>
      </div>

      <!-- 提交修改原因 -->
      <div class="writeBox" v-if="editData.status>2">
        <p class="title">修改原因</p>
        <div class="writeItem" style="width:90%">
          <el-input class="input" type="textarea" v-model.trim="op_reason" placeholder="请输入修改原因" size='mini'></el-input>
        </div>
      </div>
    </div>
    <!-- button  -->
    <div class="buttones">
      <button class="yes" @click="orderUpdate()">{{editData.status>2?'提交审核':'提交'}}</button>
      <button @click="orderCancelClick">取消</button>
    </div>
  </div>
</template>
<script>
export default {
  props: ['editDataTotal'],
  data () {
    return {
      editData: JSON.parse(JSON.stringify(this.editDataTotal)),
      pickerOptions: {
        // disabledDate(time) {
        //     return time.getTime() > Date.now();
        // },
      },
      companyList: [],
      mediumList: [],
      op_reason: ''
    }
  },
  created () {
    this.userInfo = JSON.parse(this.$cookie.getCookie('userInfo'));
    this.getMediumList();
    this.companyListEvent();//线下付款公司
  },
  methods: {
    clearNoNum ({ value, valueName, mainName }) {//判断只能输入纯数字或者小数点，及负整数
      var t = value.charAt(0);
      //先把非数字的都替换掉，除了数字和.
      value = value.replace(/[^\d.]/g, "");
      //必须保证第一个为数字而不是.
      value = value.replace(/^\./g, "");
      //保证只有出现一个.而没有多个.
      value = value.replace(/\.{2,}/g, ".");
      //保证.只出现一次，而不能出现两次以上
      value = value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
      //如果第一位是负号，则允许添加   如果不允许添加负号 可以把这块注释掉
      if (t == '-') {
        value = '-' + value;
      }
      if (mainName) {
        this[mainName][valueName] = value
      } else {
        this[valueName] = value
      }
    },
    orderCancelClick () {
      this.$emit('cancelToast')
    },
    orderUpdate () {//编辑订单
      if (this.editData.status > 2 && this.op_reason == '') {
        this.$message({
          message: '请输入修改原因！',
          type: 'warning'
        })
        return
      }
      this.$loading(this.$loadingConfig)
      this.$axios.post(this.URL.BASEURL + this.URL.orderMcnUpdate, {
        id: this.editData.id,
        mcn_name: this.editData.mcn_name,
        mcn_user: this.editData.mcn_user,
        mcn_handler: this.editData.mcn_handler,
        organization_amount: this.editData.organization_amount,
        mcn_final_amount: this.editData.mcn_final_amount,
        op_reason: this.editData.status > 2 ? this.op_reason : '',
        verify_edit: this.editData.status > 2 ? 1 : 0

      }).then((res) => {
        var res = res.data;
        this.$loading(this.$loadingConfig).close()
        if (res && res.errno == 0) {
          this.$alert('编辑成功！', '成功', {
            dangerouslyUseHTMLString: true,
            confirmButtonText: '确定',
            callback: action => {
              this.$emit('emit_refresh')
            }
          });
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.$loading(this.$loadingConfig).close()
      })
    },
    companyListEvent () {//线下付款公司
      this.$axios.get(this.URL.BASEURL + this.URL.companyList, {
        params: {
          page: 1,
          page_size: 999,
        }
      }).then((res) => {
        var res = res.data;
        if (res && res.errno == 0) {
          this.companyList = res.rst.data;
          this.companyList.forEach((item) => {
            if (item.is_default == 1) {
              this.editData.offline_subsidy_company = item.company_name
            }
          });
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
      })
    },
    getMediumList () {
      this.$axios.get(this.URL.BASEURL + this.URL.users, {
        params: {
          page: 1,
          page_size: 999,
          role_id: 9
        }
      }).then((res) => {
        var res = res.data;
        this.loading = false;
        if (res && res.errno == 0) {
          var arr = res.rst.data;
          this.mediumList = arr.filter((v) => {
            return v.real_name
          })
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
      })
    },
  },
  watch: {
  }
}
</script>
<style lang="scss" scoped>
@import "./edit.scss";
</style>


// WEBPACK FOOTER //
// src/components/Order/medium/mcnEdit.vue